import { render, staticRenderFns } from "./SidebarSubItem.vue?vue&type=template&id=662525fe&style=background-color%3A%20%23007dc2%3B%20border-color%3A%20%23007dc2%3B&"
import script from "./SidebarSubItem.vue?vue&type=script&lang=js&"
export * from "./SidebarSubItem.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSubItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports